import { Stack, Typography } from '@mui/material';
import { LoadingMessasge } from 'customer_portal-ui-shared';
import { useMsal } from '@azure/msal-react';

import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import NearMeIcon from '@mui/icons-material/NearMe';
import { useEffect, useState } from 'react';
import { getAuthToken, PortCodeService } from '../../service';

/**
 * @param {aisData} props Vesssel Location as per AIS.
 */
const VesselDestination = ({ aisData, imoNumber, onMOU, tableRowIndex }) => {
    const { instance, accounts } = useMsal();

    const [isLoading, setIsLoading] = useState(true);
    const [portCode, setPortCode] = useState();
    const [portCodeCountry, setPortCodeCountry] = useState();

    const [mouData, setMOUData] = useState();

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            await getData();
            setIsLoading(false);
        })();
    }, [aisData]);

    useEffect(() => {
        (async () => {
            if (!imoNumber || !onMOU) return;

            onMOU(imoNumber, mouData, tableRowIndex);
        })();
    }, [mouData]);

    useEffect(() => {
        if (!portCode) return;

        setMOUData(portCode.MOU);
    }, [portCode]);

    useEffect(() => {
        if (!portCodeCountry) return;

        setMOUData(portCodeCountry.MOU);
    }, [portCodeCountry]);

    const getData = async () => {
        if (aisData && aisData.Destination) {
            const authToken = await getAuthToken(instance, accounts);
            const portCodeResult = await PortCodeService.getSearch(authToken, aisData.Destination);
            setPortCode(portCodeResult);

            if (!portCodeResult) {
                const portCodeCountryResult = await PortCodeService.getSearchCountryLookup(authToken, aisData.Destination);
                setPortCodeCountry(portCodeCountryResult);
            }
        }
    };

    return (
        <>
            {isLoading && <LoadingMessasge />}
            {!isLoading && (
                <>
                    {!aisData && (
                        <>
                            <Stack direction={'row'} spacing={1} alignItems={'center'} justifyContent={'flex-start'}>
                                <ErrorOutlineOutlinedIcon sx={{ height: '18px' }} />
                                <Stack direction={'column'} spacing={0.5} alignItems={'flex-start'}>
                                    Not Found
                                    <Typography variant="caption" display="block">
                                        Note: Unable to Get AIS Data
                                    </Typography>
                                </Stack>
                            </Stack>
                        </>
                    )}

                    {aisData && portCode && (
                        <>
                            <Stack direction={'row'} spacing={1} alignItems={'center'} justifyContent={'flex-start'}>
                                <NearMeIcon sx={{ height: '18px' }} />
                                <Stack direction={'column'} spacing={0.5} alignItems={'flex-start'}>
                                    {aisData.Destination}
                                    <Typography variant="caption" display="block">
                                        {portCode && <>{`${portCode.PortName}, ${portCode.Country}`}</>}
                                    </Typography>
                                </Stack>
                            </Stack>
                        </>
                    )}

                    {aisData && !portCode && portCodeCountry && portCodeCountry.Country && (
                        <>
                            <Stack direction={'row'} spacing={1} alignItems={'center'} justifyContent={'flex-start'}>
                                <ErrorOutlineOutlinedIcon sx={{ height: '18px' }} />
                                <Stack direction={'column'} spacing={0.5} alignItems={'flex-start'}>
                                    {aisData.Destination}
                                    <Typography variant="caption" display="block">
                                        {`${portCodeCountry.Country} (approximate)`}
                                    </Typography>
                                </Stack>
                            </Stack>
                        </>
                    )}

                    {aisData && !portCode && (!portCodeCountry || !portCodeCountry.Country) && (
                        <>
                            <Stack direction={'row'} spacing={1} alignItems={'center'} justifyContent={'flex-start'}>
                                <NearMeIcon sx={{ height: '18px' }} />
                                <Stack direction={'column'} spacing={0.5} alignItems={'flex-start'}>
                                    {aisData.Destination}
                                    <Typography variant="caption" display="block">
                                        {`Note: Unable to match a Port Code.`}
                                    </Typography>
                                </Stack>
                            </Stack>
                        </>
                    )}
                </>
            )}
        </>
    );
};

export default VesselDestination;
